// Whether Check Wind is open. The Tools menu opens it and closes itself; the map shows it until it is closed.

const _listeners = new Set()
let _open = false

export const checkWindStore = {
  get open() { return _open },

  set(v) {
    _open = !!v
    _listeners.forEach(fn => fn())
  },

  onChange(fn) {
    _listeners.add(fn)
    return () => _listeners.delete(fn)
  }
}
